import { useLocation } from 'react-router-dom';
import { whatsappLink } from '@/lib/whatsapp';

const HIDDEN_ON = ['/preventivo', '/checkout'];

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M16.04 3C8.86 3 3.02 8.83 3.02 16c0 2.29.6 4.53 1.75 6.5L3 29l6.68-1.75A13 13 0 0 0 16.04 29C23.2 29 29 23.17 29 16S23.2 3 16.04 3Zm0 23.8c-2 0-3.95-.54-5.65-1.55l-.4-.24-3.96 1.04 1.06-3.86-.26-.4A10.77 10.77 0 0 1 5.2 16c0-5.96 4.86-10.8 10.84-10.8 5.97 0 10.8 4.84 10.8 10.8 0 5.96-4.83 10.8-10.8 10.8Zm5.93-8.08c-.32-.16-1.92-.95-2.22-1.06-.3-.11-.51-.16-.73.16-.21.32-.84 1.06-1.03 1.27-.19.22-.38.24-.7.08-.33-.16-1.38-.5-2.62-1.6-.97-.87-1.62-1.93-1.81-2.26-.19-.32-.02-.5.14-.66.15-.15.33-.38.49-.57.16-.19.21-.32.32-.54.11-.21.05-.4-.03-.57-.08-.16-.73-1.75-1-2.4-.26-.63-.53-.54-.73-.55h-.62c-.21 0-.56.08-.86.4-.3.33-1.13 1.1-1.13 2.69 0 1.58 1.16 3.12 1.32 3.33.16.22 2.28 3.48 5.53 4.88.77.33 1.37.53 1.84.68.77.25 1.48.21 2.04.13.62-.1 1.92-.79 2.19-1.55.27-.76.27-1.42.19-1.55-.08-.14-.3-.22-.62-.38Z" />
  </svg>
);

export const WhatsAppButton = () => {
  const { pathname } = useLocation();
  if (HIDDEN_ON.some((p) => pathname.startsWith(p))) return null;
  const onProduct = pathname.startsWith('/prodotto/');

  return (
    <a
      href={whatsappLink('Ciao, vorrei qualche informazione sui vostri gioielli.')}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Scrivici su WhatsApp"
      className={`group fixed right-5 md:right-8 z-40 flex items-center animate-scale-in ${
        onProduct ? 'bottom-24 lg:bottom-8' : 'bottom-5 md:bottom-8'
      }`}
      data-testid="whatsapp-float-btn"
    >
      <span className="hidden md:block mr-3 px-4 py-2 rounded-full glass border border-line text-eyebrow text-ink opacity-0 translate-x-2 pointer-events-none transition-[opacity,transform] duration-hover group-hover:opacity-100 group-hover:translate-x-0">
        Scrivici su WhatsApp
      </span>
      <span className="relative w-12 h-12 rounded-full glass border border-line text-ink flex items-center justify-center shadow-md shadow-ink/10 transition-colors duration-hover group-hover:bg-bordeaux group-hover:border-bordeaux group-hover:text-ivory">
        <WhatsAppIcon className="w-5 h-5" />
        <span className="absolute top-0.5 right-0.5 w-2.5 h-2.5 rounded-full bg-[#25D366] ring-2 ring-ivory" />
      </span>
    </a>
  );
};
